<template>
  <div class="bg-blue-5 -my-10 -mr-10 p-10 grid gap-8 text-center max-sm:hidden">
    <h3 class="h3 text-blue-1">Financial advice for everyone</h3>
    <div class="object-cover min-h-10">
      <UpgradeOtivoSVG class="mx-auto max-h-76" />
    </div>
    <div>
      <h5 class="h5 font-bold! text-primary mb-3">Be better off by $371K*</h5>
      <p class="paragraph-2 font-extralight!">
        That’s the average amount people are better off at retirement after following Otivo’s
        advice.
      </p>
    </div>
    <div class="max-w-full">
      <p class="font-bold">Trusted By</p>
      <div class="flex flex-wrap flex-auto mt-1 gap-x-5 items-center justify-center">
        <component
          v-for="(item, index) in trusted"
          :key="index"
          :is="item.component"
          class="mx-auto my-2 w-auto"
          :class="item.class" />
      </div>
    </div>
    <small class="font-light paragraph-4">
      *The figures shown reflect the average uplift in net wealth until age 65 observed across the
      Otivo user base when recommendations are followed based on user-provided data and projected
      outcomes assuming the recommended strategies are implemented through to completion.
    </small>
  </div>
</template>
<script setup lang="ts">
import UpgradeOtivoSVG from '@/components/SVGS/UpgradeOtivo.svg'
import NessSuper from '@/components/SVGS/Companies/NessSuper.svg?url'
import CFS from '@/components/SVGS/Companies/ColonialFirstState.svg?url'
import EY from '@/components/SVGS/Companies/EY.svg?url'
import Suncorp from '@/components/SVGS/Companies/Suncorp.svg?url'
import Latitude from '@/components/SVGS/Companies/Latitude.svg?url'
import Medibank from '@/components/SVGS/Companies/Medibank.svg?url'
import PacificBlue from '@/components/SVGS/Companies/PacificBlue.svg?url'
import { h } from 'vue'

const trusted = [
  { name: 'Colonial First State', component: h('img', { src: CFS, alt: 'CFS' }), class: 'h-8' },
  { name: 'Ness Super', component: h('img', { src: NessSuper, alt: 'NessSuper' }), class: 'h-4' },
  { name: 'Suncorp', component: h('img', { src: Suncorp, alt: 'Suncorp' }), class: 'h-6' },
  { name: 'Latitude', component: h('img', { src: Latitude, alt: 'Latitude' }), class: 'h-5' },
  { name: 'EY', component: h('img', { src: EY, alt: 'EY' }), class: 'h-9 ' },
  {
    name: 'Medibank',
    component: h('img', { src: Medibank, alt: 'Medibank' }),
    class: 'h-4 mt-auto',
  },
  {
    name: 'Pacific Blue',
    component: h('img', { src: PacificBlue, alt: 'PacificBlue' }),
    class: 'h-7 mt-auto ',
  },
]
</script>
